import React from 'react';
import { Link } from 'react-router-dom';

const Overview = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Company Overview</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>EGB Systems and Solutions, Inc.</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row g-5 align-items-center">
          <div className="col-12 col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-3">WHO WE ARE</span>
            <h2 className="fw-bold mb-3">Transforming E-Business Since 1999</h2>
            <p className="text-muted">EGB Systems and Solutions, Inc. is a full-service IT company headquartered in Stamford, Connecticut, USA with operations in Chennai, India. We offer a range of strategic business solutions that are comprehensive in structure, elaborate in execution, and dynamic in style.</p>
            <p className="text-muted">Our service portfolio is designed to provide complete end-to-end solutions for clients across Banking, Healthcare, IT, Telecom, Education, Tours & Travel, Hospitality, and Government sectors.</p>
            <Link to="/contact" className="btn btn-primary mt-3">Get in Touch →</Link>
          </div>
          <div className="col-12 col-lg-6">
            <div className="row g-3">
              {[{ icon: '🏅', label: 'ISO 9001:2000 Certified' }, { icon: '🏛️', label: 'GSA Contract Holder' }, { icon: '📊', label: 'INC 500 | Rank #213' }, { icon: '⭐', label: 'CMMI Level 5' }, { icon: '25+', label: 'Years of Experience' }, { icon: '500+', label: 'Happy Clients' }].map(item => (
                <div key={item.label} className="col-6">
                  <div className="card border-0 shadow-sm p-3 text-center h-100">
                    <div style={{ fontSize: 28 }} className="mb-2">{item.icon}</div>
                    <div className="fw-semibold small">{item.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Overview;
